module.exports = __webpack_public_path__ + "static/media/Calor.5bd6bfe2.jpg";